import React, { useState } from "react";
import Header from "../OrderManagement/Header"; // Adjust the path as needed
import {
  Box,
  Typography,
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import Input from "../../ui/Input";
import DateField from "../../ui/DateField";
import InboxIcon from "@mui/icons-material/Inbox";
import InfoIcon from "@mui/icons-material/Info";
import { headers } from "../../utils/utils";

const Form = () => { 
  const [formData, setFormData] = useState({
    id: "",
    customer: "",
    billToAddress: "",
    shipToAddress: "",
    orderDate: new Date().toISOString().split("T")[0], // Default to today's date
    customFields: [],
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value, // Dynamically update the field
    }));
  };

  const [customField, setCustomField] = useState([]);

  const fetchCustomFields = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_TICKET_SERVER +
          "/systemConfig/getDynamicFields?screenName=Item Screen",
        {
          method: "GET",
          headers: headers(),
        },
      );
      if (!response.ok) {
        throw new Error("Failed to fetch custom fields");
      }
      const data = await response.json(); // Assuming the API returns JSON data
      setCustomField(data); // Update the state with API response
      console.log("res", data);
    } catch (error) {
      console.error("Error fetching custom fields:", error);
    }
  };

  const [tableRows, setTableRows] = useState([
    {
      item: "",
      deliveryDate: "",
      uom: "",
      discount: "",
      amount: "",
      total: "",
    },
  ]);

  const handleRowChange = (index, field, value) => {
    const updatedRows = [...tableRows];
    updatedRows[index][field] = value;
    setTableRows(updatedRows);
  };

  const addRow = () => {
    setTableRows([
      ...tableRows,
      {
        item: "",
        deliveryDate: "",
        uom: "",
        discount: "",
        amount: "",
        total: "",
      },
    ]);
  };

  const deleteRow = (index) => {
    const updatedRows = tableRows.filter((_, i) => i !== index);
    setTableRows(updatedRows);
  };

  return (
    <>
      <Header />

      <Box
        p={3}
        sx={{
          margin: "20px",
          boxShadow: 100,
          borderRadius: 2,
          background: "white",
        }}
      >
        <div
          className="form-label"
          style={{ display: "flex", alignItems: "center" }}
        >
          <h3 style={{ display: "flex", alignItems: "center" }}>
            <InboxIcon /> Order
          </h3>
        </div>

        <Box p={2}>
          <Typography variant="h6" gutterBottom>
            Order Details
          </Typography>
          <Grid container spacing={5} className="form-l1">
            <Input
              label="Customer"
              name="customer"
              icon={InfoIcon}
              grid="3"
              placeHolder="Customer"
              onChange={handleInputChange}
            />
            <Input
              label="Bill to Address"
              name="billToAddress"
              icon={InfoIcon}
              grid="3"
              placeHolder="Bill To Address"
              onChange={handleInputChange}
            />
            <Input
              label="Ship to Address"
              name="shipToAddress"
              icon={InfoIcon}
              grid="3"
              placeHolder="Ship To Address"
              onChange={handleInputChange}
            />
            <DateField
              label="Order Date"
              name="orderDate"
              value={formData.orderDate} 
              onChange={handleInputChange} 
            />
          </Grid>

          {/* Table Section */}
          <Box mt={3}>
            <Typography variant="h6" gutterBottom>
              Order Items
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Item</TableCell>
                    <TableCell>Delivery Date</TableCell>
                    <TableCell>UOM</TableCell>
                    <TableCell>Discount</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableRows.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <TextField
                          name="item"
                          value={row.item}
                          onChange={(e) =>
                            handleRowChange(index, "item", e.target.value)
                          }
                          placeholder="Item"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name="deliveryDate"
                          type="date"
                          value={row.deliveryDate}
                          onChange={(e) =>
                            handleRowChange(
                              index,
                              "deliveryDate",
                              e.target.value,
                            )
                          }
                          fullWidth
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name="uom"
                          value={row.uom}
                          onChange={(e) =>
                            handleRowChange(index, "uom", e.target.value)
                          }
                          placeholder="UOM"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name="discount"
                          value={row.discount}
                          onChange={(e) =>
                            handleRowChange(index, "discount", e.target.value)
                          }
                          placeholder="Discount"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name="amount"
                          value={row.amount}
                          onChange={(e) =>
                            handleRowChange(index, "amount", e.target.value)
                          }
                          placeholder="Amount"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell>
                        <TextField
                          name="total"
                          value={row.total}
                          onChange={(e) =>
                            handleRowChange(index, "total", e.target.value)
                          }
                          placeholder="Total"
                          fullWidth
                        />
                      </TableCell>
                      <TableCell>
                        <IconButton onClick={() => deleteRow(index)}>
                          <DeleteIcon color="error" />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box mt={2}>
              <Button
                startIcon={<AddCircleIcon />}
                variant="contained"
                color="primary"
                onClick={addRow}
              >
                Add Row
              </Button>
            </Box>
          </Box>

          <Box mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => console.log("Form Data Submitted:", formData)} // Log form data on submit
            >
              Save Order
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Form;
